namespace Portico.Models.Gateway {

export enum NoteTypeCategory {
    // NOTE
    NOTE = 1,
    // TASK
    TASK = 2,
    // EVENT
    EVENT = 3,
    // NDEF
    DefaultNoteType = 4,
}

export enum RoleType {
    // UNKN
    UNKNOWN = 0,
    // PAT
    PATIENT = 1,
    // PSRB
    PRESCRIBER = 2,
    // INS
    INSURANCEPROVIDER = 3,
    // PBM
    PHARMACYBENEFITMANAGER = 4,
    // SEC
    SECONDARYCONTACT = 5,
    // MFT
    MANUFACTURER = 6,
    // EMP
    EMPLOYEE = 7,
    // CSR
    CUSTOMERSERVICEREP = 8,
    // PSRBSITE
    PRESCRIBERSITE = 9,
    // BRAND
    BRAND = 10,
    // CHLD
    CHILD = 11,
    // SCWRK
    SOCIALWORKER = 12,
    // FINREP
    FINANCIALREPRESENTATIVE = 13,
    // LGLREP
    LEGALREPRESENTATIVE = 14,
    // COR
    CORPORATE = 15,
    // PERCNT
    PERSONALCONTACT = 16,
    // SPOUSE
    SPOUSE = 17,
    // PARENT
    PARENT = 18,
    // HMHEALTH
    HOMEHEALTH = 19,
    // ALTCNT
    ALTERNATECONTACT = 20,
    // AUTOINJ
    AUTOINJURYPLAN = 21,
    // COMMPL
    COMMERCIALPLAN = 22,
    // FEDPL
    FEDERALEMPLOYEEPROGRAM = 23,
    // MEDAD
    MEDICAID = 24,
    // MDCRAD
    MEDICAREADVANTAGE = 25,
    // MDCRB
    MEDICAREB = 26,
    // MDCRD
    MEDICARED = 27,
    // MDGP
    MEDIGAP = 28,
    // VATC
    VADODTRICARE = 29,
    // WRKCMP
    WORKERSCOMPENSATION = 30,
    // PLAN
    PLAN = 31,
    // PAYER
    PAYER = 32,
    // DMEP
    DURABLEMEDICALEQUIPMENTPLAN = 33,
    // MCMP
    MANAGEDCAREMEDICAIDPLAN = 34,
    // SPAP
    STATEPHARMACYASSISTANCEPROGRAM = 35,
    // MEDAB
    MEDICAREPARTABPLAN = 36,
    // ADAP
    AIDSDRUGASSISTANCEPROGRAM = 37,
    // STPL
    STATEPLAN = 38,
    // PRVD
    PROVIDER = 39,
    // EPO
    EXCLUSIVEPROVIDERORGANIZATION = 40,
    // INDEM
    INDEMNITYINSURANCE = 41,
    // HMO
    HEALTHMAINTENANCEORGANIZATION = 42,
    // POSP
    POINTOFSERVICEPLAN = 43,
    // PPO
    PREFERREDPROVIDERORGANIZATION = 44,
    // SELF
    SELF = 45,
    // OFFCNT
    OFFICECONTACT = 46,
    // PHARM
    PHARMACY = 47,
    // MDCRA
    MEDICAREA = 48,
    // HOSP
    HOSPITAL = 49,
    // HOSPOP
    HOSPITALOUTPATIENT = 50,
    // INFCTR
    INFUSIONCENTER = 51,
    // RETPHAR
    RETAILPHARMACY = 52,
    // Foundation
    Foundation = 53,
    // SecSupp
    SecondarySupplemental = 54,
    // RegNurse
    RegisteredNurse = 55,
    // LicPractNurse
    LicensedPracticalNurse = 56,
    // CertNursingAsst
    CertifiedNursingAssistant = 57,
    // MedAsst
    MedicalAssistant = 58,
    // NatlHealthAgncy
    NationalHomeHealthAgency = 59,
    // IndlHealthAgncy
    IndependentHomeHealthAgency = 60,
    // Practice
    Practice = 61,
    // PDCI
    PerDiemContractIndividual = 62,
    // Employee
    Employee = 63,
}

export enum ContactInfoType {
    // UNKN
    UNKNOWN = 0,
    // PHONE
    PHONE = 1,
    // MOBILE
    MOBILE = 2,
    // FAX
    FAX = 3,
    // WEB
    WEB = 4,
    // E-MAIL
    EMAIL = 5,
    // DNC
    DONOTCALL = 6,
    // FACEBOOK
    FACEBOOK = 7,
    // TWITTER
    TWITTER = 8,
    // LINKEDIN
    LINKEDIN = 9,
    // GOOGLEPLUS
    GOOGLEPLUS = 10,
    // YOUTUBE
    YOUTUBE = 11,
    // Text
    Text = 12,
    // Mail
    Mail = 13,
}

export enum CaseExternalIdType {
    // ARXCID
    ARXCID = 1,
    // NPID
    NPID = 2,
    // TRANID
    TRANID = 3,
    // MemberNumber
    MemberNumber = 4,
    // Mig
    Mig = 5,
    // MedMemberID
    MedMemberID = 6,
    // PharMemberID
    PharMemberID = 7,
    // CaseMaskID
    CaseMaskID = 8,
    // TCClaimID
    TCClaimID = 9,
    // DispositionCode
    DispositionCode = 10,
    // ARXRxId
    ARXRxId = 11,
    // StgVirmedicaDFID
    StgVirmedicaDFID = 12,
    // TCEobID
    TCEobID = 13,
    // ThirdPartyId
    ThirdPartyId = 14,
    // CarePathId
    CarePathId = 15,
    // VRMResponseId
    VRMResponseId = 16,
    // VRMTransactionId
    VRMTransactionId = 17,
    // VRMBVId
    VRMBVId = 18,
    // VRMPatientId
    VRMPatientId = 19,
    // SiteAccountId
    SiteAccountId = 20,
    // OtbnStgVirmedicaDFID
    OtbnStgVirmedicaDFID = 21,
}

export enum AddressType {
    // UNKNOWN
    UNKNOWN = 0,
    // CORPORATE HEADQUARTERS
    CORPORATEHEADQUARTERS = 1,
    // SALES OFFICE
    SALESOFFICE = 2,
    // RESIDENTIAL ADDRESS
    RESIDENTIALADDRESS = 3,
    // WORK ADDRESS
    WORKADDRESS = 4,
    // SEASONAL ADDRESS
    SEASONALADDRESS = 5,
    // MAILING ADDRESS
    MAILINGADDRESS = 6,
    // BILLING ADDRESS
    BILLINGADDRESS = 7,
    // SHIPPING ADDRESS
    SHIPPINGADDRESS = 8,
}

export enum SystemStatus {
    // OTH
    OTHER = 0,
    // Open
    Open = 1,
    // Closed
    Closed = 2,
}

export enum ContactInfoPurposeType {
    // UNKN
    UNKNOWN = 0,
    // MAIN
    MAIN = 1,
    // MKTG
    MARKETING = 2,
    // SALES
    SALES = 3,
    // CUSTSER
    CUSTOMERSERVICE = 4,
    // HOME
    HOME = 5,
    // WORK
    WORK = 6,
    // SEAS
    SEASONAL = 7,
    // OTHR
    OTHER = 8,
}

export enum CaseCaseFollowUpSyncAction {
    // Sync from Case Entities from Account Entities
    SyncFromAccount = 0,
    // Complete
    SyncFromCase = 1,
    // Manually sync using case relationships in the CaseFollowUpResultModel
    Manual = 2,
}

export enum CaseCaseFollowUpScenario {
    // Nothing/error route
    Undetermined = 0,
    // Create Workflow
    CreateCase = 1,
}

export enum ActualType {
    // Standalone Case
    StandaloneCase = 1,
    // Workflow
    Workflow = 2,
    // Workflow Case (sub-case to a Workflow)
    WorkflowCase = 3,
}

export enum ClaimJobType {
    // IMS Medical Claim Feed
    ImsClaimFeed = 1,
    // IMS Reconciliation (Payment Batch) Feed
    ImsReconciliationFeed = 2,
}

export enum DiagnosisType {
    // UNKN
    UNKN = 0,
    // ICD9
    ICD9 = 1,
    // ICD10
    ICD10 = 2,
    // DSM4
    DSM4 = 3,
    // J-CODE
    JCODE = 4,
    // CPT Code
    CPTCode = 5,
    // Q-CODE
    QCODE = 6,
}

export enum DocumentStatus {
    // UNKN
    UNKN = 0,
    // LOAD
    LOAD = 1,
    // PEND
    PEND = 2,
    // MISSINFO
    MISSINFO = 3,
    // PRCSED
    PRCSED = 4,
    // UNASGN
    UNASGN = 5,
    // NOTRD
    NOTRD = 6,
    // SKIP
    SKIP = 7,
    // EXP
    EXP = 8,
    // Sent
    Sent = 9,
    // Void
    Void = 10,
    // Submit
    Submit = 11,
    // Success
    Success = 12,
    // Failure
    Failure = 13,
    // Open
    Open = 14,
    // Requested
    Requested = 15,
    // Printed
    Printed = 16,
    // PrintFailed
    PrintFailed = 17,
    // NeedsReview
    NeedsReview = 18,
    // UnderReview
    UnderReview = 19,
    // DocumentRejected
    DocumentRejected = 20,
    // DocumentApproved
    DocumentApproved = 21,
    // SMSSucessfull
    SMSSucessfull = 22,
    // SMSFailure
    SMSFailure = 23,
    // PrintQueued
    PrintQueued = 24,
    // Resent
    Resent = 25,
    // Returned
    Returned = 26,
    // Acknowledged
    Acknowledged = 27,
    // Damaged
    Damaged = 28,
    // UnverifiedAddress
    UnverifiedAddress = 29,
}

export enum DocumentGroupSource {
    // UNKN
    UNKN = 0,
    // WEB
    WEB = 1,
    // InMail
    InMail = 2,
    // Infax
    Infax = 3,
    // Inemail
    Inemail = 4,
    // FEED
    FEED = 5,
    // UPD
    UPD = 6,
    // OutMail
    OutMail = 7,
    // OutFax
    OutFax = 8,
    // OutEmail
    OutEmail = 9,
    // Mig
    Mig = 10,
    // Phone
    Phone = 11,
    // WebService
    WebService = 12,
    // DataFeed
    DataFeed = 13,
    // TCPortal
    TCPortal = 14,
    // SystemCreated
    SystemCreated = 15,
    // Mail
    Mail = 16,
    // Fax
    Fax = 17,
    // Email
    Email = 18,
    // SMS
    SMS = 19,
}

export enum DocumentGroupStatus {
    // UNKN
    UNKN = 0,
    // LOAD
    LOAD = 1,
    // PEND
    PEND = 2,
    // MISSINFO
    MISSINFO = 3,
    // PRCSED
    PRCSED = 4,
    // UNASGN
    UNASGN = 5,
    // NOTRD
    NOTRD = 6,
    // SKIP
    SKIP = 7,
    // EXP
    EXP = 8,
}

export enum TransmissionType {
    // INB
    INB = 1,
    // OUTB
    OUTB = 2,
}

export enum EmailErrorCode {
    // No Error
    NoError = 0,
    // User Id Not Found
    UserIdNotFound = 1,
    // Bronto Error
    BrontoError = 2,
    // General Error
    GeneralError = 3,
    // Warning
    Warning = 100,
}

export enum MessageContentType {
    // HTML
    Html = 1,
    // Text
    Text = 2,
}

export enum TCSCommunicationType {
    // None
    None = 0,
    // Letter
    Letter = 1,
    // Email
    Email = 2,
    // SMS
    SMS = 4,
    // Phone
    Phone = 8,
    // Fax
    Fax = 16,
}

export enum TCSInsuranceType {
    // Pharmacy
    Pharmacy = 1,
    // Medical
    Medical = 2,
    // Medical / Pharmacy
    Both = 3,
}

export enum TCSSource {
    // Unknown
    Unknown = 0,
    // Janssen CarePath One Patient Portal
    Patient = 5,
    // Janssen CarePath One Provider Portal
    Provider = 6,
    // Janssen CarePath One Hub Portal
    Hub = 7,
    // Janssen CarePath One Express Portal
    Express = 8,
    // Opus Migration
    OpusMigration = 10,
}

export enum TCSCommunicationOption {
    // Unspecified
    Unspecified = 0,
    // Opt-In
    OptIn = 1,
    // Opt-Out
    OptOut = 2,
}

export enum TCSPaymentType {
    // None
    None = 0,
    // Check to Site
    CheckToSite = 1,
    // Check to Patient
    CheckToPatient = 2,
    // Debit Card
    DebitCard = 3,
    // Check Payable to Site
    CheckPayableToSite = 4,
    // Electronic Funds Transfer
    ElectricFundsTransfer = 5,
}

export enum TCSRelationshipType {
    // Parent
    Parent = 0,
    // Legal Guardian
    LegalGuardian = 1,
    // Other
    Other = 2,
}

export enum TCSSiteType {
    // None
    None = -1,
    // Facility
    Facility = 0,
    // Infusion
    Infusion = 1,
    // Pharmacy
    Pharmacy = 2,
}

export enum TCSGileadCommOption {
    // Opt-In
    OptIn = 0,
    // Opt-Out
    OptOut = 1,
}

export enum AlternateCardType {
    // Unknown
    Unknown = 0,
    // Previous Client ID
    PreviousClientId = 1,
    // Mobile #
    MobileNumber = 2,
    // Service Request #
    ServiceRequestNumber = 3,
    // 3rd Party ID
    ThirdPartyID = 4,
}

export enum QueryStringMatch {
    // Exact
    Exact = 0,
    // Starts With
    StartsWith = 1,
    // Ends With
    EndsWith = 2,
    // Contains
    Contains = 3,
}

export enum TCSEligibilityStatus {
    // Unknown
    Unknown = -1,
    // Member number valid, but patient ineligible at this time
    PatientIneligible = 0,
    // Eligible pending survey data
    EligiblePending = 1,
    // Pending enrollment
    PendingEnrollment = 2,
    // Member number invalid
    MemberNumberInvalid = 3,
    // Activation period expired
    ActivationPeriodExpired = 4,
    // Ready to activate
    ReadyToActivate = 5,
    // Transfer to TrialCard
    TransferToTrialcard = 6,
}

export enum EligibilityScope {
    // All
    All = 4294967295,
    // Survey
    Survey = 1,
    // Patient
    Patient = 2,
    // Income
    Income = 4,
}

export enum EnrollmentType {
    // If Membernumber type is Unknown
    Unknown = 0,
    // Medical MemberNumber
    Medical = 6,
    // Pharmacy MemberNumber
    Pharmacy = 7,
}

export enum EnrollmentStatus {
    // Approved Enrollment Status
    Approved = 0,
    // Rejected Enrollment Status
    Rejected = 1,
    // Review Required Enrollment Status
    Review_Required = 2,
    // Case Processing After Review
    Review_Processing = 3,
    // Case Processing After Intake
    Intake_Processing = 4,
    // Disenrolled
    Disenrolled = 5,
    // Enrolled
    Enrolled = 6,
    // Canceled
    Canceled = 7,
    // Open
    Open = 8,
    // Unknown
    Unknown = -1,
    // EXPired
    EXP = 9,
}

export enum EnrollmentEligibility {
    // didn't even try
    Undetermined = 0,
    // yes
    Passed = 1,
    // no
    Failed = 2,
}

export enum EnrollmentScenario {
    // Nothing/error rout
    Undetermined = 0,
    // create a new initial enrollment or an enrollment after a time gap
    NewEnrollment = 1,
    // update an existing enrollment
    Update = 2,
    // end an existing enrollment early and create a new one for the remaining time 
    KeyUpdate = 3,
    // create a new enrollment in the future, despite the patient having a current enrollment
    ReEnrollment = 4,
    // End all existing enrollments without creating anything new.
    DisEnrollment = 5,
}

export enum EnrollmentJobState {
    // Running
    Running = 0,
    // Complete
    Complete = 1,
    // Error
    Error = 2,
}

export enum EnrollmentJobType {
    // QP Enrollment Feed
    EnrollmentFeed = 1,
}

export enum Gender {
    // UNKN
    UNKN = 0,
    // M
    M = 1,
    // F
    F = 2,
    // I
    I = 3,
}

export enum AccountType {
    // PAT
    PATIENT = 1,
    // PRESCRIBER
    PRESCRIBER = 2,
    // SITE
    SITE = 3,
}

export enum AccountStatus {
    // UNKN
    UNKNOWN = 0,
    // ACT
    ACTIVE = 1,
    // INACT
    INACTIVE = 2,
}

export enum PayorType {
    // INS
    INS = 3,
    // PBM
    PBM = 4,
    // PAYER
    PAYER = 32,
}

export enum PharmacyType {
    // OTH
    OTHER = 0,
    // RTL
    RETAIL = 1,
    // LAB
    LABORATORY = 2,
    // HOS
    HOSPITAL = 3,
    // MCO
    MANAGEDCAREORGINIZATION = 4,
    // RET
    RESIDENTIALTREATMENT = 5,
}

export enum PharmacySpecialization {
    // OTH
    OTH = 0,
    // CRP
    CRP = 1,
    // SPR
    SPR = 2,
    // CMP
    CMP = 3,
    // HIT
    HIT = 4,
    // CLP
    CLP = 5,
    // MOP
    MOP = 6,
    // MCO
    MCO = 7,
    // IFT
    IFT = 8,
    // PRC
    PRC = 9,
    // NFS
    NFS = 10,
}

export enum ContactDatePreferenceType {
    // UNKN
    UNKNOWN = 0,
    // DAY
    DAY = 1,
    // BTWDAY
    BETWEENDATES = 2,
    // HOLDY
    HOLIDAY = 3,
    // WKEND
    WEEKENDS = 4,
    // WKDAY
    WEEKDAYS = 5,
}

export enum ContactTimePreferenceType {
    // UNKN
    UNKNOWN = 0,
    // TM
    TIMEOFTHEDAY = 1,
    // BTWTM
    BETWEENTIMES = 2,
    // ANYTM
    ANYTIME = 3,
    // BUSHR
    BUSINESSHOURS = 4,
    // EVNTM
    EVENINGTIMES = 5,
}

export enum ExternalIdType {
    // UNKN
    UNKNOWN = 0,
    // MBRID
    MEMBERID = 1,
    // SSN
    SOCIALSECURITYNUMBERSSN = 2,
    // EIN
    FEDERALEMPLOYERIDENTIFICATIONNUMBEREIN = 3,
    // DL
    DRIVERSLICENSENUMBER = 4,
    // DEA
    DEANUMBER = 5,
    // NPI
    NPINUMBER = 6,
    // GRP
    GROUPID = 7,
    // EMP
    EMPLOYEEID = 8,
    // STLIC
    STATELICENSENUMBER = 9,
    // PCN
    PROCESSORCONTROLLERNUMBER = 10,
    // BIN
    BANKIDENTIFICATIONNUMBER = 11,
    // MEDID
    MEDICALID = 12,
    // ISGV
    ISGOVERNMENT = 13,
    // ARXCN
    ASSISTRXCASENUMBER = 14,
    // ISBENPL
    ISMEDICALBENEFIT = 15,
    // COVSTDT
    COVERAGESTARTDATE = 16,
    // COVENDDT
    COVERAGEENDDATE = 17,
    // PLYR
    PLANYEAR = 18,
    // VirmedicaPracId
    VirmedicaPraticeID = 19,
    // VirmedicaLocId
    VirmedicaLocationID = 20,
    // VirmedicaPrvdId
    VirmedicaProviderID = 21,
    // VirmedicaHCPPrvdId
    VirmedicaHCPProviderID = 22,
    // VMMasterPayerID
    VirmedicaMasterPayerID = 23,
    // VMPayerID
    VirmedicaPayerID = 24,
    // MaxRTEPayorID
    MaxRTEPayorID = 25,
    // PTAN
    ProviderTransactionAccessNumber = 26,
}

export enum PlanType {
    // HMHEALTH
    HMHEALTH = 19,
    // AUTOINJ
    AUTOINJ = 21,
    // COMMPL
    COMMPL = 22,
    // FEDPL
    FEDPL = 23,
    // MEDAD
    MEDAD = 24,
    // MDCRAD
    MDCRAD = 25,
    // MDCRB
    MDCRB = 26,
    // MDCRD
    MDCRD = 27,
    // MDGP
    MDGP = 28,
    // VATC
    VATC = 29,
    // WRKCMP
    WRKCMP = 30,
    // PLAN
    PLAN = 31,
    // DMEP
    DMEP = 33,
    // MCMP
    MCMP = 34,
    // SPAP
    SPAP = 35,
    // MEDAB
    MEDAB = 36,
    // ADAP
    ADAP = 37,
    // STPL
    STPL = 38,
    // EPO
    EPO = 40,
    // INDEM
    INDEM = 41,
    // HMO
    HMO = 42,
    // POSP
    POSP = 43,
    // PPO
    PPO = 44,
    // MDCRA
    MDCRA = 48,
    // SecSupp
    SecSupp = 54,
    // Employee
    Employee = 63,
}

export enum PrescriberLicenseType {
    // UNKNOWN
    UNKNOWN = 0,
    // DRUG ENFORCEMENT ADMINISTRATION NUMBER
    DRUGENFORCEMENTADMINISTRATIONNUMBER = 1,
    // STATE LICENSE ID
    STATELICENSEID = 2,
    // MEDICAID ID
    MEDICAIDID = 3,
}

export enum EscoordJobType {
    // QP Enrollment Feed
    EnrollmentFeed = 1,
}

export enum Dpv {
    // DPV unknown or not provided
    Unknown = 0,
    // Address is a valid mailing address
    Valid = 1,
    // Address is not in the DPV database of valid mailing addresses
    Invalid = 2,
    // Apartment or Rural Route Box invalid
    AptOrRrBoxInvalid = 3,
    // Apartment or Rural Route Box missing
    AptOrRrBoxMissing = 4,
}

export enum LocationCorrection {
    // LACSLink conversion
    LacsLinkConversion = 1,
    // Derived primary number
    DerivedPrimaryNumber = 2,
    // City name determined by ZIP4 alternate
    CityDerivedFromZip4Alternate = 3,
    // Street name changed to preferred alias
    StreetNameChanged = 4,
    // Input ZIP4 retained
    Zip4Retained = 8,
    // Directional or Suffix changed
    DirectionalOrSuffixChanged = 9,
    // City changed
    CityChanged = 10,
    // Added unit designator and secondary number
    AddedUnitAndSecondaryNumber = 11,
    // Implied city based on ZIP
    CityDerivedFromZip = 12,
    // Modified primary or secondary number
    ModifiedPrimaryOrSecondaryNumber = 13,
    // Pre or post directional change
    PreOrPostDirectionalChange = 15,
    // City name changed
    CityNameChanged = 17,
    // Street suffix changed
    StreetSuffixChanged = 18,
    // Directional shift
    DirectionalShift = 19,
    // ZIP code changed
    ZipChanged = 22,
    // State changed
    StateChanged = 23,
    // Swapped Line 1 and Line 2
    SwappedLine1AndLine2 = 30,
    // Dropped invalid info in Line 2
    DroppedInvalidLine2 = 31,
}

export enum PartyExternalIdType {
    // UNKN
    UNKNOWN = 0,
    // MBRID
    MEMBERID = 1,
    // SSN
    SOCIALSECURITYNUMBERSSN = 2,
    // EIN
    FEDERALEMPLOYERIDENTIFICATIONNUMBEREIN = 3,
    // DL
    DRIVERSLICENSENUMBER = 4,
    // DEA
    DEANUMBER = 5,
    // NPI
    NPINUMBER = 6,
    // GRP
    GROUPID = 7,
    // EMP
    EMPLOYEEID = 8,
    // STLIC
    STATELICENSENUMBER = 9,
    // PCN
    PROCESSORCONTROLLERNUMBER = 10,
    // BIN
    BANKIDENTIFICATIONNUMBER = 11,
    // MEDID
    MEDICALID = 12,
    // ISGV
    ISGOVERNMENT = 13,
    // ARXCN
    ASSISTRXCASENUMBER = 14,
    // ISBENPL
    ISMEDICALBENEFIT = 15,
    // COVSTDT
    COVERAGESTARTDATE = 16,
    // COVENDDT
    COVERAGEENDDATE = 17,
    // PLYR
    PLANYEAR = 18,
    // VirmedicaPracId
    VirmedicaPraticeID = 19,
    // VirmedicaLocId
    VirmedicaLocationID = 20,
    // VirmedicaPrvdId
    VirmedicaProviderID = 21,
    // VirmedicaHCPPrvdId
    VirmedicaHCPProviderID = 22,
    // VMMasterPayerID
    VirmedicaMasterPayerID = 23,
    // VMPayerID
    VirmedicaPayerID = 24,
    // MaxRTEPayorID
    MaxRTEPayorID = 25,
    // PTAN
    ProviderTransactionAccessNumber = 26,
}

export enum PharmacyJobType {
    // Triage to Pharmacy Inbound Feed
    T2PInboundFeed = 1,
}

export enum ProgramPartyType {
    // UNKN
    UNKNOWN = 0,
    // P
    PERSON = 1,
    // O
    ORGANIZATION = 2,
    // OTH
    OTHERS = 3,
    // Empty
    PlaceholderForNonentity = 4,
}

export enum ProgramUsageType {
    // Hub
    Hub = 1,
    // Copay
    Copay = 2,
    // Pap
    PatientAssitanceProgram = 3,
}

export enum AuthenticateStatus {
    // 
    Valid = 'valid',
    // 
    AccountNotFound = 'accountNotFound',
    // 
    AccountDisabled = 'accountDisabled',
    // 
    AccountLocked = 'accountLocked',
    // 
    PasswordExpired = 'passwordExpired',
    // 
    ServerError = 'serverError',
    // 
    UserFound = 'userFound',
    // 
    NotAuthenticated = 'notAuthenticated',
    // 
    SessionExpired = 'sessionExpired',
    // 
    SessionValid = 'sessionValid',
    // 
    UserMustChangePassword = 'userMustChangePassword',
}

export enum AccountExternalIdType {
    // 
    UNKN = 0,
    // 
    UBCHUBID = 1,
    // 
    TrialCardHubId = 2,
    // 
    MemberNumber = 3,
    // 
    ADLDS = 4,
    // 
    MedMemberID = 5,
    // 
    PharMemberID = 6,
    // 
    THIRDPARTYID = 7,
    // 
    ARXRxId = 8,
    // 
    CarePathId = 9,
    // 
    VMIPatientId = 10,
    // 
    PorticoPortalId = 11,
    // 
    SiteAccountId = 12,
    // 
    PatientMckId = 13,
    // 
    RemsId = 14,
}

export enum Extauth2ValidateStatus {
    // 
    Valid = 0,
    // 
    UserFound = 1,
    // 
    Invalid = 2,
    // 
    UserNotFound = 3,
    // 
    AccountDisabled = 4,
    // 
    AccountLocked = 5,
    // 
    PasswordExpired = 6,
    // 
    ServerError = 7,
    // 
    UserMustChangePassword = 8,
}

export enum TCSDocumentType {
    // 
    None = 0,
    // 
    Claim = 1,
    // 
    Correspondence = 2,
}

export enum Extauth2ChangePasswordStatus {
    // 
    Success = 0,
    // 
    Failed = 1,
}

export enum Extauth2ProfileUpdateStatus {
    // 
    Success = 0,
    // 
    Failed = 1,
}

export enum DebitCardMapStatus {
    // 
    PENDING = 1,
    // 
    ACTIVE = 2,
    // 
    INACTIVE = 3,
}

export enum ProcessorType {
    // 
    I2C = 3,
    // 
    Alegeus = 9,
    // 
    TChek = 10,
}

export enum DebitCardVmcUsageRegion {
    // 
    Unknown = 0,
    // 
    USA = 1,
    // 
    international = 2,
}

export enum EnrollPatientCaseInitiator {
    // 
    patient = 'patient',
    // 
    pharmacy = 'pharmacy',
    // 
    provider = 'provider',
}

export enum TcSystem {
    // 
    plp = 'plp',
    // 
    qp = 'qp',
}

export enum ClaimTypeCode {
    // 
    pha = 'pha',
    // 
    med = 'med',
}

export enum EnrollmentApiPaymentType {
    // 
    debitcard = 'debitcard',
    // 
    check = 'check',
    // 
    virtualdebitcard = 'virtualdebitcard',
    // 
    thirdpartyadjudication = 'thirdpartyadjudication',
    // 
    sitecheckforpatient = 'sitecheckforpatient',
    // 
    sitecheckforsite = 'sitecheckforsite',
    // 
    efttosite = 'efttosite',
    // 
    copaycard = 'copaycard',
}
}